<template>
  <h1>
    <v-form
      class="username__textfield"
    >
          <v-text-field
              v-model="bindText"
              :rules="rules.name"
              color="grey darken-4"
              label="ツイート自動生成したいアカウント名を入力"
              clearable
              outlined
              required
              placeholder="twigene_aitter"
          ></v-text-field>
    </v-form>
  </h1>
</template>

<script>
  export default {
    data () {
      // const defaultForm = Object.freeze({
      //   selectAccountName: 'twigene_aitter',
      // })
      return {
        // form: Object.assign({}, defaultForm),
        rules: {
          name: [val => (val || null).length > 0 || '自動生成したいアカウント名を入力して下さい<br>代わりについじぇね運営のツイートを生成します…'],
        },
        // defaultForm,
        selectAccountName: null,
        checkbox: true,
        loginUserName: ''
      }
    },
    computed: {
      formIsValid () {
        return (
          this.form.selectAccountName
        )
      },
        isLogin () {
        return this.$store.getters['auth/check']
        },
        userinfo () {
        return this.$store.getters['auth/user']
        },
        bindText: {
          get () {
            var loginUser = this.$store.getters['auth/user']
            var iniUser = this.selectAccountName
            if (!this.selectAccountName) {
                this.$emit('generateScreenName', "twigene_aitter")
              } else {
                // アカウント名変更後はテキストフィールド の値を送る
                this.$emit('generateScreenName', this.selectAccountName)
              }
            // return this.selectAccountName
            // ログインユーザーがいたらselectAccountName(テキストフィールドの値)を変える
            if (loginUser) {
              iniUser = loginUser.screenName
              // ログイン初期、テキストフィールドのモデルが初期値だったらログイン情報を親コンポーネントに送る
              if (!this.selectAccountName) {
                this.$emit('generateScreenName', "twigene_aitter")
              } else {
                // アカウント名変更後はテキストフィールド の値を送る
                this.$emit('generateScreenName', this.selectAccountName)
              }
            } else {
              // 未ログインだったらデフォルト（ついじぇねユーザーアカウントを送る）
              this.$emit('generateScreenName', "twigene_aitter")
            }
            return iniUser
          },
          // テキストが変更されたら親コンポーネントに送る
          set (value) {
            if (value) {
              this.selectAccountName = value
            }
          }
        }
    }
  }
</script>

<style>
.username__textfield {
  max-height: 50px;
  margin: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectGenerateUser.vue